/* action type */
import type { Action } from '../../store/state/state-manager';

export const SUBMIT_BULK_ACTION_ASYNC = 'SUBMIT_BULK_ACTION_ASYNC';

/* action creator */
export const submitBulkActionAsync = (actionPayload: Action['payload']) => {
  return {
    type: SUBMIT_BULK_ACTION_ASYNC,
    payload: actionPayload
  };
};
